/*
 * --------------------------------------------------------------------------- *
 * File: datatypelist.js                                                       *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { getDataTypeNames, getDataTypeDetails } from "../data/datatypeutils";
import Constants from "../main/constants";
import { AppContext } from "../main/context";
import { addSpaceBeforeCaps } from "../main/utilities";

function DataTypeList() {
  var list = getDataTypeNames();
  var { setSelectedEditDataType, setShowNow } = useContext(AppContext);

  return (
    <div className="row p-5">
      <div className="col-sm-12 center">
        <h2>Available Data Types</h2>
        <hr />
      </div>
      {list.map((d, i) => {
        return (
          <div className="col-sm-6">
            <button
              key={i}
              className="btn btn-secondary wide mt-3 shadow-lg border border-dark border-2"
              onClick={(e) => {
                setSelectedEditDataType(getDataTypeDetails(d));
                setShowNow(Constants.SHOW_NOW_DATA_TYPE_EDIT);
              }}
            >
              {addSpaceBeforeCaps(d)}
            </button>
          </div>
        );
      })}
      <div className="col-12 p-3">
        <button
          className="btn btn-primary wide mt-3"
          onClick={(e) => {
            setSelectedEditDataType({});
            setShowNow(Constants.SHOW_NOW_DATA_TYPE_EDIT);
          }}
        >
          Create Data Type
        </button>
      </div>
    </div>
  );
}

export default DataTypeList;
